/**
 * Assessment types enum
 */
export var AssessmentType;
(function (AssessmentType) {
    AssessmentType["FIRSTMONITORING"] = "FIRSTMONITORING";
    AssessmentType["SECONDMONITORING"] = "SECONDMONITORING";
    AssessmentType["MOVE"] = "MOVE";
    AssessmentType["CHANGEOFROOM"] = "CHANGEOFROOM";
    AssessmentType["ADDCONTACTPERSON"] = "ADDCONTACTPERSON";
    AssessmentType["CHANGECONTACTPERSON"] = "CHANGECONTACTPERSON";
    AssessmentType["REMOVECONTACTPERSON"] = "REMOVECONTACTPERSON";
    AssessmentType["CHANGEEMAILCONTACTPERSON"] = "CHANGEEMAILCONTACTPERSON";
    AssessmentType["CHANGEEMAILSPECIALIST"] = "CHANGEEMAILSPECIALIST";
    AssessmentType["CHANGEBILLINGEMAIL"] = "CHANGEBILLINGEMAIL";
    AssessmentType["CHANGEBANKACCOUNTDATA"] = "CHANGEBANKACCOUNTDATA";
    AssessmentType["CHANGEBILLADDRESS"] = "CHANGEBILLADDRESS";
    AssessmentType["CHANGEOFCEO"] = "CHANGEOFCEO";
    AssessmentType["CHANGEOFOWNER"] = "CHANGEOFOWNER";
    AssessmentType["CHANGESPECIALIST"] = "CHANGESPECIALIST";
    AssessmentType["ADDSPECIALIST"] = "ADDSPECIALIST";
    AssessmentType["REMOVESPECIALIST"] = "REMOVESPECIALIST";
    AssessmentType["EXTENDPROVIDINGFIELDS"] = "EXTENDPROVIDINGFIELDS";
    AssessmentType["REMOVEPROVIDINGFIELDS"] = "REMOVEPROVIDINGFIELDS";
    AssessmentType["CHANGECOMPANYNAME"] = "CHANGECOMPANYNAME";
    AssessmentType["CHANGEOFLEGALFORM"] = "CHANGEOFLEGALFORM";
    AssessmentType["OPENINSOLVENCY"] = "OPENINSOLVENCY";
    AssessmentType["CLOSECOMPANY"] = "CLOSECOMPANY";
})(AssessmentType || (AssessmentType = {}));
/**
 * Status types enum (shared across multiple models)
 */
export var StatusType;
(function (StatusType) {
    StatusType["CREATED"] = "CREATED";
    StatusType["PENDING"] = "PENDING";
    StatusType["COMPLETED"] = "COMPLETED";
    StatusType["FAILED"] = "FAILED";
    StatusType["CANCELED"] = "CANCELED";
    StatusType["IN_PROGRESS"] = "IN_PROGRESS";
    StatusType["UNDER_REVIEW"] = "UNDER_REVIEW";
    StatusType["REJECTED"] = "REJECTED";
    StatusType["ACCEPTED"] = "ACCEPTED";
    StatusType["DOCUMENT_REVIEW"] = "DOCUMENT_REVIEW";
    StatusType["MONITORING"] = "MONITORING";
    StatusType["INSOLVENCY"] = "INSOLVENCY";
})(StatusType || (StatusType = {}));
/**
 * German status labels for UI display
 * Maps StatusType enum values to their German translations
 */
export var StatusLabel;
(function (StatusLabel) {
    StatusLabel["CREATED"] = "In Bearbeitung";
    StatusLabel["PENDING"] = "In Pr\u00FCfung";
    StatusLabel["COMPLETED"] = "Abgeschlossen";
    StatusLabel["FAILED"] = "Fehlgeschlagen";
    StatusLabel["CANCELED"] = "Abgesagt";
    StatusLabel["IN_PROGRESS"] = "Laufend";
    StatusLabel["UNDER_REVIEW"] = "Zur \u00DCberpr\u00FCfung freigegeben";
    StatusLabel["REJECTED"] = "Abgelehnt";
    StatusLabel["ACCEPTED"] = "Akzeptiert";
    StatusLabel["DOCUMENT_REVIEW"] = "Dokumentenpr\u00FCfung";
    StatusLabel["MONITORING"] = "\u00DCberwachung";
    StatusLabel["INSOLVENCY"] = "Insolvenz";
})(StatusLabel || (StatusLabel = {}));
/**
 * Action list item types enum
 */
export var ActionListItemType;
(function (ActionListItemType) {
    ActionListItemType["DEFAULT"] = "DEFAULT";
    ActionListItemType["REQUEST"] = "REQUEST";
    ActionListItemType["INSPECTION"] = "INSPECTION";
    ActionListItemType["DOCUMENTREVIEW"] = "DOCUMENTREVIEW";
    ActionListItemType["MONITORING"] = "MONITORING";
    ActionListItemType["CHANGES"] = "CHANGES";
    ActionListItemType["REMINDER"] = "REMINDER";
})(ActionListItemType || (ActionListItemType = {}));
/**
 * History types enum
 */
export var HistoryType;
(function (HistoryType) {
    HistoryType["WITHOUTEMAILANDATTACHMENTS"] = "WITHOUTEMAILANDATTACHMENTS";
    HistoryType["WITHATTACHMENTS"] = "WITHATTACHMENTS";
    HistoryType["WITHEMAIL"] = "WITHEMAIL";
    HistoryType["WITHATTACHMENTSANDEMAIL"] = "WITHATTACHMENTSANDEMAIL";
    HistoryType["WITHXMLFILE"] = "WITHXMLFILE";
})(HistoryType || (HistoryType = {}));
/**
 * Inspection types enum
 */
export var InspectionType;
(function (InspectionType) {
    InspectionType["INITIAL"] = "INITIAL";
    InspectionType["CONTINUED"] = "CONTINUED";
    InspectionType["MONITORING"] = "MONITORING";
    InspectionType["CHANGERELATED"] = "CHANGERELATED";
    InspectionType["RISK"] = "RISK";
    InspectionType["OTHER"] = "OTHER";
})(InspectionType || (InspectionType = {}));
/**
 * XML file types enum
 */
export var XMLFileType;
(function (XMLFileType) {
    XMLFileType["INITIAL"] = "INITIAL";
    XMLFileType["CORRECTION"] = "CORRECTION";
    XMLFileType["SUSPENSION"] = "SUSPENSION";
    XMLFileType["WITHDRAWAL"] = "WITHDRAWAL";
})(XMLFileType || (XMLFileType = {}));
/**
 * Notes types enum
 */
export var NotesType;
(function (NotesType) {
    NotesType["REMINDER"] = "REMINDER";
    NotesType["TASK"] = "TASK";
})(NotesType || (NotesType = {}));
/**
 * Billing types enum
 */
export var BillingType;
(function (BillingType) {
    BillingType["DIRECTDEBIT"] = "DIRECTDEBIT";
    BillingType["BANKTRANSFER"] = "BANKTRANSFER";
})(BillingType || (BillingType = {}));
/**
 * Billing due types enum
 */
export var BillingDueType;
(function (BillingDueType) {
    BillingDueType["QUARTAL"] = "QUARTAL";
    BillingDueType["DIRECT"] = "DIRECT";
    BillingDueType["YEARLY"] = "YEARLY";
})(BillingDueType || (BillingDueType = {}));
/**
 * Notification preference enum
 */
export var NotificationPreference;
(function (NotificationPreference) {
    NotificationPreference["IMMEDIATE"] = "IMMEDIATE";
    NotificationPreference["DAILY_DIGEST"] = "DAILY_DIGEST";
})(NotificationPreference || (NotificationPreference = {}));
/**
 * Collective invoice types enum
 */
export var CollectiveInvoiceType;
(function (CollectiveInvoiceType) {
    CollectiveInvoiceType["INSPECTION"] = "INSPECTION";
    CollectiveInvoiceType["BASIC"] = "BASIC";
    CollectiveInvoiceType["ASSESSMENT"] = "ASSESSMENT";
    CollectiveInvoiceType["FINAL"] = "FINAL";
})(CollectiveInvoiceType || (CollectiveInvoiceType = {}));
